import { quickTags, heroStats } from "@/mocks/homeMeta";

export default function Hero() {
  return (
    <section id="top" className="relative w-full bg-background-100 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.5] bg-[radial-gradient(oklch(var(--background-300))_1px,transparent_1px)] [background-size:22px_22px]" />
      <div className="relative w-full px-4 md:px-6 py-12 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-start">
          <div className="lg:col-span-7 kd-fade-up">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-900 text-xs font-label border border-accent-200">
              <i className="ri-shield-check-line text-sm w-4 h-4 flex items-center justify-center" />
              辟谣与反转专区 · 持续跟踪
            </span>

            <h1 className="mt-5 font-heading text-foreground-950">
              <span className="block text-sm md:text-base tracking-[0.35em] text-primary-700 font-medium mb-3">
                蝌蚪黑料
              </span>
              <span className="block text-3xl md:text-5xl font-bold leading-[1.2]">
                辟谣与反转专区
              </span>
            </h1>

            <p className="mt-5 text-lg md:text-xl font-heading font-medium text-foreground-800 leading-relaxed">
              真假在变，回应也在变 —— 这里把每一轮说法排在一起。
            </p>

            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl">
              本站集中跟踪真假变化、涉事声明和相关后续。点开就能对照各方在说什么、补时间线看回应一轮，适合吃瓜时不容易被跑。我们对每条信息标注当前状态，证据不足时只说“待核实”，等下一轮回应再更新。
            </p>

            <form
              onSubmit={(e) => e.preventDefault()}
              className="mt-7 flex flex-col sm:flex-row gap-3 max-w-2xl"
            >
              <div className="flex-1 flex items-center gap-2 bg-background-50 border border-background-300 rounded-md px-4 h-12">
                <i className="ri-search-line text-foreground-500 text-base w-4 h-4 flex items-center justify-center" />
                <input
                  type="text"
                  placeholder="输入事件、人物或关键词，看看哪一版是真的"
                  className="w-full bg-transparent text-sm font-label text-foreground-900 placeholder:text-foreground-400 outline-none"
                />
              </div>
              <button
                type="submit"
                className="h-12 px-6 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-label transition-colors whitespace-nowrap cursor-pointer"
              >
                查一查辟谣记录
              </button>
            </form>

            <div className="mt-5 flex flex-wrap items-center gap-2">
              <span className="text-xs font-label text-foreground-500">大家在找：</span>
              {quickTags.map((tag) => (
                <a
                  key={tag}
                  href="#board"
                  className="px-3 py-1.5 rounded-full bg-background-50 border border-background-200 text-xs font-label text-foreground-700 hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {tag}
                </a>
              ))}
            </div>

            <div className="mt-9 grid grid-cols-3 gap-4 max-w-xl">
              {heroStats.map((stat) => (
                <div key={stat.label} className="border-l-2 border-background-300 pl-3">
                  <div className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                    {stat.value}
                  </div>
                  <div className="mt-1 text-xs font-label text-foreground-500">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5 w-full kd-fade-up" style={{ animationDelay: "0.15s" }}>
            <div className="relative w-full h-[280px] md:h-[380px] rounded-lg overflow-hidden border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20editorial%20still%20life%20of%20a%20magnifying%20glass%20resting%20on%20blurred%20newspaper%20sheets%2C%20warm%20amber%20light%20beam%2C%20deep%20charcoal%20background%2C%20fine%20film%20grain%2C%20abstract%20textures%2C%20no%20people%20no%20text%2C%20moody%20investigative%20atmosphere&width=1000&height=800&seq=kd-hero-01&orientation=squarish"
                alt="蝌蚪黑料辟谣专区配图"
                title="蝌蚪黑料辟谣 反转 真假对照"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="text-xs font-label tracking-widest text-primary-300 mb-1">
                  本轮跟踪
                </div>
                <div className="font-heading text-lg font-semibold text-background-50 leading-snug">
                  录音剪辑之争 · 已进入第二轮回应
                </div>
              </div>
            </div>

            <div className="mt-4 grid grid-cols-3 gap-3">
              <div className="rounded-lg bg-background-50 border border-background-200 p-3">
                <div className="text-[11px] font-label text-foreground-500">状态</div>
                <div className="mt-1 text-sm font-label font-medium text-primary-700">
                  出现反转
                </div>
              </div>
              <div className="rounded-lg bg-background-50 border border-background-200 p-3">
                <div className="text-[11px] font-label text-foreground-500">声明</div>
                <div className="mt-1 text-sm font-label font-medium text-foreground-900">
                  5 份
                </div>
              </div>
              <div className="rounded-lg bg-background-50 border border-background-200 p-3">
                <div className="text-[11px] font-label text-foreground-500">更新</div>
                <div className="mt-1 text-sm font-label font-medium text-accent-700">
                  27 条
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}